import { Input, Form, Checkbox } from "antd";
import { CheckOutlined } from '@ant-design/icons';
import './EmailInput.scss';

const EmailInput = ({
  inputName,
  inputRules,
  inputTitle,
  inputPlaceholder,
  required,
  setRequiredEmail
}) => {
  return (
    <div className="customized_email">
      <Form.Item className="customized_email_wrapper">
        <Checkbox onChange={e => setRequiredEmail(e.target.checked)} defaultChecked={require} className="customized_email_checkbox" name="allow_email">
          <CheckOutlined className="customized_email_checkmark">
            &#10004;
          </CheckOutlined>
        </Checkbox>
      </Form.Item>

      <Form.Item
        name={inputName}
        rules={[...inputRules, ( required ? { required: true, message: '電子信箱為必填' } : {} )]}
      >
        <Input
          prefix={inputTitle}
          className="input__group-text"
          placeholder={inputPlaceholder}
        />
      </Form.Item>
    </div>
  );
};

export default EmailInput;